module.exports = __webpack_public_path__ + "91044e957321b7ec06bebbc7d5fc9a7b.png";